/** Picks v2 or v1 of the Premium Access Requests page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import PremiumManagementPage   from './PremiumManagementPage';
import PremiumManagementPageV2 from './v2/PremiumManagementPageV2';

export default function PremiumManagementPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? PremiumManagementPageV2 : PremiumManagementPage;
  return <Component {...props} />;
}
